import React from 'react';
import { styled } from 'linaria/react';
import Image from '@jetshop/ui/Image/Image';
import { theme } from '../Theme';

const EmployeesWrapper = styled('div')`
  max-width: 80rem;
  padding: 0 32px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin: 0 auto;

  ${theme.below.lg} {
    flex-direction: column;
  }
`;

const EmployeesItemWrapper = styled('div')`
  display: flex;
  width: 100%;
  max-width: 50%;
  gap: 20px;
  margin-bottom: 32px;

  ${theme.below.lg} {
    max-width: 100%;
    flex-direction: column;
  }
`;

const EmployeesItemImageWrapper = styled('div')`
  width: 100%;
  max-width: 50%;

  ${theme.below.lg} {
    max-width: 100%;
  }
`;

const EmployeesItemInformationWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;

  p,
  h3,
  a {
    margin: 0;
    color: #000;
    text-transform: none;
    text-decoration: none;
  }

  ${theme.below.lg} {
    margin-top: 10px;
  }
`;

export const EmployeesItem = ({
  profileImage,
  name,
  title,
  telephone,
  direct,
  mail,
}) => {
  return (
    <EmployeesItemWrapper>
      <EmployeesItemImageWrapper>
        <Image src={profileImage?.value} alt={name} />
      </EmployeesItemImageWrapper>
      <EmployeesItemInformationWrapper>
        <div className="name-title">
          <h3>{name?.value}</h3>
          <p>{title?.value}</p>
        </div>
        <div>
          <p>
            Tel: <a href={`tel:${telephone?.value}`}>{telephone?.value}</a>
          </p>
          <p>
            Direkt: <a href={`tel:${direct?.value}`}>{direct?.value}</a>
          </p>
          <p>
            Mail: <a href={`mailto:${mail?.value}`}>{mail?.value}</a>
          </p>
        </div>
      </EmployeesItemInformationWrapper>
    </EmployeesItemWrapper>
  );
};

export const Employees = ({ children }) => {
  return <EmployeesWrapper>{children}</EmployeesWrapper>;
};
